import React from 'react'

function BuyerDashborad() {
  return (
    <div>coming soon</div>
  )
}

export default BuyerDashborad